module.exports = __webpack_public_path__ + "img/skate-quiz-synchronized-male.695785e4.png";